<template>
	<div class="downMain">
		<div class="container">
			<div class="showImage">
				<img src="images/share/down1.jpg" />
			</div>
			<div class="downContent">
				<button class="downBtn" @click="downApp">下载APP</button>
				<p class="downTips">下载APP立享加油优惠</p>
			</div>
		</div>
		<div class="bottomIcon">
			<img src="images/share/down2.png" />
		</div>
	</div>
</template>

<script lang="ts">
export default {
	data() {
		return {

		}
	},

	methods: {
		downApp() {
			this.$router.push({
				name: "share"
			})
		}
	}
}
</script>

<style scoped>
.downMain {
	height: 100%;
	background: #f5f5f5;
	display: flex;
	flex-flow: column;
	justify-content: space-between;
}

.container {
    flex: none;
}

.showImage {
	width: 100%;
	height: 127.067vw;
}

.downBtn {
	width: 65.067vw;
	height: 12.8vw;
	background-color: #00d10b;
	box-shadow: 0vw 0.533vw 2.133vw 0vw rgba(87, 209, 49, 0.4);
    border-radius: 6.4vw;
    border: none;
    outline: none;
    color: white;
    display: block;
    margin: 11.733vw auto 0;
}

.downTips {
    font-size: 3.467vw;
    color: #406661;
    text-align: center;
    margin-top: 5.333vw;
}

.showImage > img,
.bottomIcon > img {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.bottomIcon {
	width: 100%;
	height: 13.866vw;
}
</style>
